// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardFloorsComponent } from './components/floors/dashboard-floors.component';
import { TranslateModule } from '@ngx-translate/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { dashboardFloorsReducer, STATE_NAME } from './store/dashboard-floors.reducer';
import { DashboardFloorsEffects } from './store/dashboard-floors.effects';
import { ListModule } from '@coa/app/shared/list/list.module';
import { RepeatElementModule } from '@coa/app/shared/repeat-element/repeat-element.module';
import { LoadMoreModule } from '@coa/app/shared/load-more/load-more.module';
import { DashboardFloorsHeaderComponent } from './components/floors/dashboard-floors-header/dashboard-floors-header.component';
import { DashboardFloorsListComponent } from './components/floors/dashboard-floors-body/dashboard-floors-list/dashboard-floors-list.component';
import { DashboardFloorsShowAllComponent } from './components/floors/dashboard-floors-body/dashboard-floors-show-all/dashboard-floors-show-all.component';
import { DashboardFloorsSkeletonComponent } from './components/floors/dashboard-floors-body/dashboard-floors-skeleton/dashboard-floors-skeleton.component';
import { DashboardFloorsErrorComponent } from './components/floors/dashboard-floors-body/dashboard-floors-error/dashboard-floors-error.component';
import { DashboardFloorsEmptyComponent } from './components/floors/dashboard-floors-body/dashboard-floors-empty/dashboard-floors-empty.component';
import { DashboardFloorsBodyComponent } from './components/floors/dashboard-floors-body/dashboard-floors-body.component';

@NgModule({
  declarations: [
    DashboardFloorsComponent,
    DashboardFloorsHeaderComponent,
    DashboardFloorsListComponent,
    DashboardFloorsShowAllComponent,
    DashboardFloorsSkeletonComponent,
    DashboardFloorsErrorComponent,
    DashboardFloorsEmptyComponent,
    DashboardFloorsBodyComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ListModule,
    RepeatElementModule,
    StoreModule.forFeature(STATE_NAME, dashboardFloorsReducer),
    EffectsModule.forFeature([DashboardFloorsEffects]),
    LoadMoreModule,
  ],
  exports: [
    DashboardFloorsComponent,
  ],
})
export class DashboardFloorsModule {
}
